import { cx } from "./ui";

/** The official Seva Sangrah emblem: interlocking navy and sage arcs. */
export function LogoMark({ className = "h-8 w-8", light }: { className?: string; light?: boolean }) {
  return (
    <svg viewBox="0 0 200 200" fill="none" className={className} aria-hidden>
      <path d="M 122 54 C 112 32, 80 24, 60 40 C 40 56, 38 82, 54 100 C 66 112, 76 112, 88 112" stroke={light ? "#ffffff" : "#1B2A4A"} strokeWidth="15" strokeLinecap="round" />
      <circle cx="88" cy="112" r="8" fill={light ? "#ffffff" : "#1B2A4A"} />
      <path d="M 78 146 C 88 168, 120 176, 140 160 C 160 144, 162 118, 146 100 C 134 88, 124 88, 112 88" stroke={light ? "#9fd0b4" : "#356852"} strokeWidth="15" strokeLinecap="round" />
      <circle cx="112" cy="88" r="8" fill={light ? "#9fd0b4" : "#356852"} />
    </svg>
  );
}

export function Wordmark({ light, className }: { light?: boolean; className?: string }) {
  return (
    <span className={cx("inline-flex items-center gap-2.5", className)}>
      <LogoMark className="h-7 w-7" light={light} />
      <span className={cx("text-[15px] font-semibold tracking-[0.14em]", light ? "text-white" : "text-ink-800")}>
        SEVA <span className={light ? "text-[#9fd0b4]" : "text-sage-600"}>SANGRAH</span>
      </span>
    </span>
  );
}
